import { useNavigate, useParams } from 'react-router-dom';
import { useGetDeviceDetailsQuery } from 'src/api/device';
import { useGlobalModals } from 'src/contexts/global-modals';
import { links } from 'src/router/routes';

export const useDeviceDetails = () => {
  const { id } = useParams();
  const deviceId = Number(id);
  const navigate = useNavigate();

  const { data, isPending } = useGetDeviceDetailsQuery(deviceId);
  const { openDeleteDeviceModal, openRestartDeviceModal } = useGlobalModals();

  const handleDelete = () => {
    openDeleteDeviceModal(deviceId);
  };

  const handleRestart = () => {
    openRestartDeviceModal(deviceId);
  };

  const handleCancel = () => {
    navigate(links.devices);
  };

  return {
    device: data,
    isPending,
    handleDelete,
    handleRestart,
    handleCancel,
  };
};
